<!-- Schedule session form -->
<form
    #createSessionForm="ngForm"
    (ngSubmit)="onSubmit(createSessionForm)"
    novalidate
    class="w-full flex flex-col justify-start items-center gap-2 animation-fade-in">
    <p-datepicker
        appendTo="body"
        class="w-full"
        styleClass="w-full"
        inputStyleClass="w-full"
        size="large"
        name="date"
        [minDate]="minDate"
        dateFormat="MM d"
        [(ngModel)]="formModel.date"
        [readonlyInput]="true"
        [iconDisplay]="'input'"
        [showIcon]="true"
        inputId="templatedisplay"
        [firstDayOfWeek]="startOfWeekDay"
        [selectOtherMonths]="true"
        (onSelect)="onDateSelected($event)">
        <ng-template #inputicon let-clickCallBack="clickCallBack">
            <i class="pi pi-chevron-down" (click)="clickCallBack($event)"></i>
        </ng-template>
    </p-datepicker>
    <p-select
        size="large"
        class="w-full"
        [ngClass]="{ 'ng-dirty ng-invalid': selectionInvalid }"
        appendTo="body"
        [options]="timeSlotValues"
        [(ngModel)]="formModel.selectedTimeValue"
        (onChange)="selectedTimeSlot($event)"
        name="selectedTimeOption"
        optionLabel="name"
        optionValue="value"
        optionDisabled="disabled"
        [overlayOptions]="{ baseZIndex: 5000 }" />

    @if (false) {
        <!-- TODO: create tasks in booking hub -->
        <fm-booking-hub-task-form
            class="w-full"
            [tasks]="queuedTasks"
            (tasksChange)="queuedTasks = $event" />
    }

    <p-button
        [buttonProps]="{ autofocus: false }"
        size="small"
        severity="secondary"
        [text]="true"
        [label]="!expandMoreOptions ? 'Show more options' : 'Hide more options'"
        styleClass="!text-12"
        (click)="onClickShowMoreOptions()" />

    <div #container class="animate-height-snappy w-full">
        @if (expandMoreOptions) {
            <div
                #expandedContentContainer
                class="flex flex-col w-full gap-2 opacity-0 animation-fade-in">
                <p-select
                    size="large"
                    class="w-full"
                    appendTo="body"
                    [options]="recurType"
                    [(ngModel)]="formModel.recurrenceType"
                    (onChange)="selectedRecurrenceType($event)"
                    name="recurType"
                    optionLabel="name"
                    optionValue="value" />

                @if (formModel.recurrenceType !== 1) {
                    <p-select
                        size="large"
                        class="w-full"
                        appendTo="body"
                        [options]="recurTimes"
                        [(ngModel)]="formModel.recurrenceFrequency"
                        name="recurTime"
                        aria-label="Recurrence frequency"
                        optionLabel="name"
                        optionValue="value" />
                }

                <input
                    class="w-full"
                    type="text"
                    name="title"
                    pInputText
                    pSize="large"
                    placeholder="Your session title"
                    [(ngModel)]="formModel.title" />
            </div>
        }
    </div>

    <p-button
        [buttonProps]="{ autofocus: false }"
        type="submit"
        severity="primary"
        [disabled]="selectionInvalid"
        [loading]="booking"
        size="large"
        [label]="booking ? '' : 'Schedule ' + bookCtaTimeString"
        class="w-full"
        [ngClass]="{ 'mt-4': expandMoreOptions }"
        styleClass="w-full" />
</form>
